import {
  Input,
  Level,
  LevelGroup,
  LevelItem,
  Select,
} from '@inmotionnow/momentum-components-react'
import * as React from 'react'

export interface IMemberSearchToolbarProps {
  searchTerm: string
  searchPlaceholder: string
  onSearchChange: (value: string) => void
  roleFilter: number
  onRoleFilterChange: (value: number) => void
  roleFilterOptions: Array<{ value: number; displayText: string }>
}

const MemberSearchToolbar: React.FunctionComponent<
  IMemberSearchToolbarProps
> = ({
  searchTerm,
  searchPlaceholder,
  onSearchChange,
  roleFilter,
  onRoleFilterChange,
  roleFilterOptions,
}) => (
  <Level>
    <LevelGroup position='left'>
      <LevelItem stretch>
        <Input
          id='member-search'
          placeholder={searchPlaceholder}
          value={searchTerm}
          handleChange={({ currentValue }) =>
            onSearchChange(String(currentValue))
          }
          dataTestingId='member-search-input'
        />
      </LevelItem>
    </LevelGroup>
    <LevelGroup position='right'>
      <LevelItem>
        <Select
          id='member-role-filter'
          selectedValue={roleFilter}
          selectOptions={roleFilterOptions}
          handleChange={({ currentValue }) =>
            onRoleFilterChange(Number(currentValue))
          }
          dataTestingId='member-role-filter'
        />
      </LevelItem>
    </LevelGroup>
  </Level>
)

export { MemberSearchToolbar }
